const printLabelBase = (router, purchaseOrderNumber, sku, queryData, routeName) => {
  const route = router.resolve({
    name: routeName,
    params: {
      purchaseOrderNumber,
      sku,
    },
    query: {
      data: queryData,
    },
  });

  window.open(route.href, '_blank');
};

export const printLabel = (...args) => {
  printLabelBase(...args, 'printLabel');
};

export const printLabelMixed = (...args) => {
  printLabelBase(...args, 'printLabelMixed');
};
